import React from 'react'
import { FaFacebookF } from 'react-icons/fa'
import {BsTwitter} from 'react-icons/bs'
import {MdEmail} from 'react-icons/md'
import {FaLinkedinIn} from 'react-icons/fa'
const Social = () => {
    return (
        <>
            <div className="fixed my-40 hidden md:block">
                <div className="flex flex-col ">
                    <button className='text-[#004A8B] my-1 font-bold p-3 text-[1rem] bg-gray-200 hover:bg-[#B5D1B3]'><FaFacebookF /></button>
                    <button className='text-[#004A8B] font-bold p-3 text-[1rem] bg-gray-200 hover:bg-[#B5D1B3]'><BsTwitter /></button>
                    <button className='text-[#004A8B] my-1 font-bold p-3 text-[1rem] bg-gray-200 hover:bg-[#B5D1B3]'><MdEmail /></button>
                    <button className='text-[#004A8B] font-bold p-3 text-[1rem] bg-gray-200 hover:bg-[#B5D1B3]'><FaLinkedinIn /></button>
                </div>
            </div>
        </>
    )
}

export default Social